import { Layout } from '@lifebit-ai/lds'
import React from 'react'

import { Title } from 'core/Common.styles'

import { ExportAndAccessRequestsTab } from './ExportAndAccessRequestsTab'
import { ImportRequestsTab } from './ImportRequestsTab'
import RequestsNavbarHeader from './RequestsNavbarHeader'
import * as styles from './RequestsPage.styles'
import { DataAccessRequestsTab } from './data-access-requests/DataAccessRequestsTab'
import { useRequestsPage } from './hooks/useRequestsPage'
import { RequestsTabKeys } from './requestsTabKeys'

export { ExportAndAccessSubTabKeys, RequestsTabKeys } from './requestsTabKeys'

export const RequestsPage: React.FC = () => {
  const { activeTabKey, isDataAccessTabEnabled } = useRequestsPage()

  return (
    <Layout>
      <styles.StyledHeader
        hasSeparator
        title={<Title>Requests</Title>}
        subtitle={
          <styles.HeaderSubtitleBlock>
            <RequestsNavbarHeader />
          </styles.HeaderSubtitleBlock>
        }
      />
      <styles.Content>
        {activeTabKey === RequestsTabKeys.Import ? (
          <ImportRequestsTab />
        ) : activeTabKey === RequestsTabKeys.DataAccess && isDataAccessTabEnabled ? (
          <DataAccessRequestsTab />
        ) : (
          <ExportAndAccessRequestsTab />
        )}
      </styles.Content>
    </Layout>
  )
}

export default RequestsPage
